<script setup>
import { ref } from 'vue'

const props = defineProps({
  model: {
    type: Object,
    default: () => ({}),
  },
  titleInitial: {
    type: String,
    default: null,
  },
  titleSuccess: {
    type: String,
    default: null,
  },
  formPortalId: {
    type: String,
    default: null,
  },
  formId: {
    type: String,
    default: null,
  },
})

const feedback = ref('')
const status = ref('')

function submitFeedback() {
  status.value = 'success'

  const radios = document.querySelectorAll('.feedback__radio')
  radios.forEach((radio) => {
    radio.disabled = true
  })
}

const thumbSvg = /* html */`
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 13H10V26H4C3.73478 26 3.48043 25.8946 3.29289 25.7071C3.10536 25.5196 3 25.2652 3 25V14C3 13.7348 3.10536 13.4804 3.29289 13.2929C3.48043 13.1054 3.73478 13 4 13V13Z"
      stroke="#1C4F66"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 13L15 3C15.5253 3 16.0454 3.10346 16.5307 3.30448C17.016 3.5055 17.457 3.80014 17.8284 4.17157C18.1999 4.54301 18.4945 4.98396 18.6955 5.46927C18.8965 5.95457 19 6.47471 19 7V10H26.7344C27.018 10 27.2984 10.0603 27.5569 10.1769C27.8154 10.2935 28.0461 10.4638 28.2338 10.6764C28.4215 10.889 28.5618 11.1391 28.6454 11.41C28.7291 11.681 28.7542 11.9667 28.719 12.2481L27.219 24.2481C27.1585 24.7318 26.9235 25.1767 26.558 25.4994C26.1926 25.822 25.7219 26 25.2344 26H10"
      stroke="#1C4F66"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`

const normalizedData = computed(() => {
  return {
    titleInitial: props.titleInitial !== null ? props.titleInitial : props.model?.titleInitial?.value,
    titleSuccess: props.titleSuccess !== null ? props.titleSuccess : props.model?.titleSuccess?.value,
    formId: props.formId !== null ? props.formId : props.model?.formId?.value,
    formPortalId: props.formPortalId !== null ? props.formPortalId : props.model?.formPortalId?.value,
  }
})
</script>

<template>
  <EditorialBlock
    :model="{ body: { value: '' }, bgShadow: { value: true }, bgColor: { value: '' } }"
  >
    <div class="flex flex-col">
      <form
        class="feedback sm:flex sm:items-center"
        @submit.prevent="submitFeedback"
      >
        <div class="h4 m-0!">
          <span v-if="status === 'success'">{{ normalizedData.titleSuccess }}</span>
          <span v-else>{{ normalizedData.titleInitial }}</span>
        </div>
        <ul class="feedback__list list-none flex gap-5 p-0! mt-0! mb-0! sm:ml-auto">
          <li class="feedback__item feedback__item--yes p-0">
            <label
              class="feedback__label cursor-pointer"
              for="feedback-up"
            >
              <input
                id="feedback-up"
                v-model="feedback"
                class="feedback__radio sr-only"
                type="radio"
                name="feedback"
                value="up"
                aria-label="Yes, it was helpful"
                @change="submitFeedback"
              >
              <div
                class="feedback__icon"
                v-html="thumbSvg"
              />
            </label>
          </li>
          <li class="feedback__item feedback__item--no p-0">
            <label
              class="feedback__label cursor-pointer"
              for="feedback-down"
            >
              <input
                id="feedback-down"
                v-model="feedback"
                class="feedback__radio sr-only"
                type="radio"
                name="feedback"
                value="down"
                aria-label="No, it was not helpful"
                @change="submitFeedback"
              >
              <div
                class="feedback__icon"
                v-html="thumbSvg"
              />
            </label>
          </li>
        </ul>
      </form>
      <div
        v-if="status === 'success'"
        class="mt-4 w-full"
      >
        <OneEightyFormBlock
          :model="{
            formId: { value: normalizedData.formId },
            formPortalId: { value: normalizedData.formPortalId },
            blockSpacing: false,
          }"
        />
      </div>
    </div>
  </EditorialBlock>
</template>

<style lang="scss">
@use '@/assets/css/blocks/feedback-block.scss';
</style>
